import { useTheme } from "@emotion/react";
import { Button, Modal, Paper, Typography } from "@mui/material";
import useStyles from "./styles";
import { Box } from "@mui/system";
import RatingWoman from "../../../components/artsPersonComponent/ratingWoman";

export default function ModalNotificaoAvaliacao(params) {
	const {
		setValue = () => {},
		open,
		handleClose = () => {},
		ticketsCount = "1",
	} = params;
	const theme = useTheme();
	const styles = useStyles(theme);
	const handleDirect = () => {
		handleClose();
		setValue(1);
	};
	return (
		<>
			<Modal
				open={open}
				onClose={handleClose}
				aria-labelledby="modal-modal-title"
				aria-describedby="modal-modal-description"
			>
				<Box sx={styles.containerModal}>
					<RatingWoman
						backgroundFill={theme.palette.tertiary.medium}
						circleFill={theme.palette.background.paper}
					/>
					<Box sx={styles.boxComponent}>
						<Typography
							sx={{ fontSize: "22px", fontWeight: "bold", textAlign: "center" }}
						>
							Você possui {ticketsCount} ticket{ticketsCount > 1 ? "s" : ""}{" "}
							para {ticketsCount > 1 ? "serem avaliados" : "ser avaliado"}.
							Deseja {ticketsCount > 1 ? "avaliá-los" : "avaliá-lo"} agora?
						</Typography>
					</Box>

					<Box sx={styles.containerButtons}>
						<Button onClick={handleClose} variant="text">
							Não, obrigado
						</Button>
						<Button onClick={handleDirect} variant="contained">
							Avaliar agora
						</Button>
					</Box>
				</Box>
			</Modal>
		</>
	);
}
